<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <div class="pd-20px">
        <section class="has-text-left mgb-20px">
          <p
            class="has-text-link is-size-3 has-text-weight-bold mgb-20px has-text-centered">
            {{ $t('miseAJourTarif.title')}}
          </p>
          <error-msg-component :messages="messagesPopup"
                               :error="isError"
                               :title="'miseAJourTarif.error.title'"
                               :withEmplyFields="true"
                               @close="isError = $event"/>
          <div
            class="columns is-marginless is-paddingless card-content is-multiline is-gapless">
            <p class="column is-12 has-text-default is-size-6 has-text-weight-bold">
              {{$t('miseAJourTarif.message')}}
            </p>
            <b-select class="column is-6 no-border-radius-right mgt-5px"
                      expanded v-model="type">
              <option v-for="type in typesModificationPrixUnitaire"
                      :key="type.code"
                      :value="type.code">
                {{$t(type.libelle)}}
              </option>
            </b-select>
            <input-currency isNumber="true" v-if="type === constantes.REMPLACEMENT_PU"
                            class="column is-6 no-border-radius-left mgt-5px"
                            v-model="newPU">
            </input-currency>
            <input-currency isNumber="true"
                            v-else
                            class="column is-6 no-border-radius-left mgt-5px"
                            v-model="pourcentage"
                            symbole=' %'>
            </input-currency>
          </div>
        </section>
        <div class="is-grouped pdt-20px">
          <button
            class="button btn-modal-annuler is-cancel pdh-20px"
            @click="$parent.close">
            {{$t('miseAJourTarif.actions.cancel')}}
          </button>
          <button class="button is-addOrEdit mgl-10px pdh-20px"
                  @click="sendEvent()">
            {{$t('miseAJourTarif.actions.validate')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inputCurrency from '@/components/general/inputCurrency';
import * as devisConf from '@/configuration/devisConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  props: {
    ligneRegroupement: Object,
  },
  data() {
    return {
      isError: false,
      messagesPopup: [],
      pourcentage: 0,
      newPU: 0,
      type: devisConf.MAJORATION,
      typesModificationPrixUnitaire: devisConf.LISTE_TYPE_MODIFICATION_PU,
      constantes: {
        REMPLACEMENT_PU: devisConf.REMPLACEMENT_PU,
      },
    };
  },
  components: {
    inputCurrency,
    errorMsgComponent,
  },
  methods: {
    sendEvent() {
      this.messagesPopup = [];
      if ((!this.pourcentage || this.pourcentage > 100 || this.pourcentage < 0)
        && this.type !== devisConf.REMPLACEMENT_PU) {
        this.isError = true;
        this.messagesPopup.push({
          message: 'miseAJourTarif.error.pourcentage',
        });
        return;
      }
      this.$emit('updatePrixUnitaire', this.type === devisConf.REMPLACEMENT_PU ? this.newPU : this.pourcentage, this.type);
      this.$parent.close();
    },
  },
};
</script>
